var map = {
	"./et-pk-en/assets/jerseys/default-player-jersey.webp": 46709,
	"./gp-bd-en/assets/jerseys/default-player-jersey.webp": 55800,
	"./mtn-wp-za-en/assets/jerseys/default-player-jersey.webp": 34387,
	"./mtn-za-en/assets/jerseys/default-player-jersey.webp": 88587,
	"./telkom-wp-za-en/assets/jerseys/default-player-jersey.webp": 56874,
	"./vc-za-en-demo/assets/jerseys/default-player-jersey.webp": 21895,
	"./vc-za-en/assets/jerseys/default-player-jersey.webp": 64867,
	"./wp-za-en/assets/jerseys/default-player-jersey.webp": 5059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18895;